import { loadAppleSdk as e } from "./loadAppleSdk.mjs";
//#region src/web/sdk/appleCredential.ts
async function t(t) {
	let n = crypto.randomUUID(), r = await e();
	r.init({
		clientId: t.clientId,
		scope: "name email",
		redirectURI: t.redirectURI ?? window.location.origin,
		usePopup: !0,
		nonce: n
	});
	let i = await r.signIn(), a = i.authorization?.id_token;
	if (!a) throw Error("Apple sign-in returned no id_token");
	return {
		credential: a,
		nonce: n,
		appleUser: i.user?.name ? {
			firstName: i.user.name.firstName,
			lastName: i.user.name.lastName
		} : void 0
	};
}
//#endregion
export { t as acquireAppleCredential };
